import React from 'react';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import StatusIndicator from '../../../components/StatusIndicator';
import { ApprovalRequestStatus } from '../../../__generated__/graphql';

type Props = {
  status: ApprovalRequestStatus;
  textFirst?: boolean;
};

const ApprovalRequestStatusCell: React.FC<Props> = ({ status, textFirst }) => {
  const t = useNamespacedTranslation('approvalRequest.approvalStatus');

  switch (status) {
    case ApprovalRequestStatus.Pending: {
      return (
        <StatusIndicator
          variant="warning"
          text={t('pending')}
          textFirst={textFirst}
        />
      );
    }
    case ApprovalRequestStatus.Approved: {
      return (
        <StatusIndicator
          variant="success"
          text={t('approved')}
          textFirst={textFirst}
        />
      );
    }
    case ApprovalRequestStatus.Rejected: {
      return (
        <StatusIndicator
          variant="danger"
          text={t('rejected')}
          textFirst={textFirst}
        />
      );
    }
    case ApprovalRequestStatus.Skipped: {
      return (
        <StatusIndicator
          variant="danger"
          text={t('skipped')}
          textFirst={textFirst}
        />
      );
    }
    case ApprovalRequestStatus.Unknown: {
      return <StatusIndicator text={status} textFirst={textFirst} />;
    }
  }
};

export default ApprovalRequestStatusCell;
